// extracted by mini-css-extract-plugin
module.exports = {"viewMainAwards":"src-containers-Awards-Main-styles___viewMainAwards"};